import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery'

import App from './App';


ReactDOM.render(
  <App />,
  document.getElementById('root'),
  function(){
    $('#preloader').delay(2000).fadeOut();
  }
);

